import React, { useEffect, useState } from 'react';
import AppRoutes from "./routes";
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { useStoreState } from 'easy-peasy';

function App() {
  const brandingData = useStoreState((state) => state?.paCheck?.brandingData);
  const [primaryColor, setPrimaryColor] = useState('#1544d1');
  const [primaryFontColor, setPrimaryFontColor] = useState('#f7f7f7');
  const [primaryFontFamily, setPrimaryFontFamily] = useState('Trebuchet MS, sans-serif');

  useEffect(() => {
    setPrimaryColor(brandingData?.branding?.primaryColor || '#1544d1');
    setPrimaryFontColor(brandingData?.branding?.primaryFontColor || '#f7f7f7');
    setPrimaryFontFamily(brandingData?.branding?.primaryFontFamily || 'Trebuchet MS, sans-serif');
  }, [brandingData?.branding]);
  return (
    <ThemeProvider theme={theme(
      primaryColor,
      primaryFontColor,
      primaryFontFamily,
      'Abel, sans-serif',
      '#ffffff',
    )}>
      <AppRoutes />
    </ThemeProvider>
  );
}

export default App;

